import React from "react"
import styles from "./styles.scss"
import HashLink from "components/HashLink"

const FooterLink = ({ text, to }) => (
  <HashLink to={to} text={text} className={styles.link} />
)

export default FooterLink



// WEBPACK FOOTER //
// ./src/components/Footer/FooterLink/index.jsx